// app/components/BottomNavbar.tsx
'use client';
import { Home, Heart, Newspaper, ShoppingBag, User } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface NavItem {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>; // jika icon berupa SVG
  label: string;
  href: string;
  badge?: number;
}

const BottomNavbar = () => {
  const pathname = usePathname();

  const navItems: NavItem[] = [
    {
      icon: Home,
      label: 'Beranda',
      href: '/'
    },
    {
      icon: Heart,
      label: 'Donasi',
      href: '/donasi-saya'
    },
    {
      icon: Newspaper,
      label: 'Berita',
      href: '/berita',
      badge: 3
    },
    {
      icon: ShoppingBag,
      label: 'Keranjang',
      href: '/keranjang',
      badge: 2
    },
    {
      icon: User,
      label: 'Profil',
      href: '/profil'
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-100 px-4 py-2 z-50 shadow-lg shadow-gray-200/20">
      <div className="max-w-md mx-auto">
        <div className="flex justify-around items-center">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = pathname === item.href;
            
            return (
              <Link
                key={item.href}
                href={item.href}
                className="flex flex-col items-center justify-center py-2 px-3 min-w-0 relative group"
              >
                <div className="relative">
                  {/* Active indicator background */}
                  {isActive && (
                    <div className="absolute inset-0 bg-orange-100 rounded-2xl scale-110 -z-10"></div>
                  )}
                  
                  <div className={`p-2 rounded-2xl transition-all duration-300 ${
                    isActive 
                      ? 'bg-orange-500 shadow-lg shadow-orange-200' 
                      : 'group-hover:bg-gray-100'
                  }`}>
                    <Icon 
                      className={`w-5 h-5 transition-colors duration-300 ${
                        isActive 
                          ? 'text-white' 
                          : 'text-gray-600 group-hover:text-orange-600'
                      }`} 
                    />
                  </div>
                  
                  {item.badge && (
                    <div className="absolute -top-1 -right-1 bg-gradient-to-r from-red-500 to-red-600 text-white text-xs rounded-full min-w-[18px] h-[18px] flex items-center justify-center font-semibold border-2 border-white shadow-md">
                      {item.badge}
                    </div>
                  )}
                </div>
                
                <span 
                  className={`text-xs mt-1.5 font-medium transition-colors duration-300 ${
                    isActive 
                      ? 'text-orange-600' 
                      : 'text-gray-500 group-hover:text-gray-700'
                  }`}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNavbar;